import {
    METHOD_POST,
    METHOD_DELETE,
    METHOD_GET,
    METHOD_PUT,
    SERVER_URL
} from '../constants/api';
import { headersAuthSendReceiveJson } from '../headers';
import { apiHandleResponse } from '../../util/api';

/**
 * Get list of supplementary prompts
 * @param options - Datatable options including page, sort, and filter
 */
export const getSuppPromptsDocumentsList = (options: any) => {
    // Remove null/undefined filter from payload to match API expectations
    const payload = {
        ...options,
        ...(options.filter && { filter: options.filter })
    };
    
    return fetch(`${SERVER_URL}/api/v1/genai/supplemental_prompt/list`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(payload),
    }).then(apiHandleResponse);
};

/**
 * Get single supplementary prompt by ID
 * @param suppPromptId - ID of the prompt to fetch
 */
export const getSuppPromptDocument = (suppPromptId: number) => {
    return fetch(`${SERVER_URL}/api/v1/genai/supplemental_prompt/${suppPromptId}`, {
        method: METHOD_GET,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};

/**
 * Create supplementary prompt
 * @param payload - JSON object containing contractIds (array), prompt, description, and isActive
 */
export const createSuppPromptDocument = (payload: {
    contractIds: number[];
    prompt: string;
    description?: string;
    isActive?: boolean;
}) => {
    const requestPayload = {
        contractIds: payload.contractIds,
        prompt: payload.prompt,
        ...(payload.description && { description: payload.description }),
        isActive: payload.isActive !== undefined ? payload.isActive : true
    };
    
    return fetch(`${SERVER_URL}/api/v1/genai/supplemental_prompt`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(requestPayload),
    }).then(apiHandleResponse);
};

/**
 * Update supplementary prompt
 * @param payload - JSON object containing id, contractIds (array), prompt, description, and isActive
 */
export const updateSuppPromptDocument = (payload: {
    id: number;
    contractIds: number[];
    prompt: string;
    description?: string;
    isActive?: boolean;
}) => {
    const requestPayload = {
        id: payload.id,
        contractIds: payload.contractIds,
        prompt: payload.prompt,
        ...(payload.description && { description: payload.description }),
        isActive: payload.isActive !== undefined ? payload.isActive : true
    };
    
    return fetch(`${SERVER_URL}/api/v1/genai/supplemental_prompt`, {
        method: METHOD_PUT,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(requestPayload),
    }).then(apiHandleResponse);
};

/**
 * Validate supplementary prompt before creating/updating
 * @param payload - JSON object containing prompt_text and contract_id
 */
export const validateSuppPrompt = (payload: {
    prompt_text: string;
    contract_id: number;
}) => {
    return fetch(`${SERVER_URL}/ai-api/v1/supp-prompt/validate`, {
        method: METHOD_POST,
        headers: headersAuthSendReceiveJson(),
        body: JSON.stringify(payload),
    }).then(apiHandleResponse);
};

/**
 * Delete supplementary prompt
 * @param suppPromptId - ID of the prompt to delete
 */
export const deleteSuppPromptDocument = (suppPromptId: number) => {
    return fetch(`${SERVER_URL}/api/v1/genai/supplemental_prompt/${suppPromptId}`, {
        method: METHOD_DELETE,
        headers: headersAuthSendReceiveJson(),
    }).then(apiHandleResponse);
};
